module.exports = __webpack_public_path__ + "static/img/202217.3e94ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202217.jpg
// module id = 3Byp
// module chunks = 0